var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head-box"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/assets/images/logo.png"),"alt":""}})]),_c('div',{staticClass:"title-box"},[_c('h3',[_vm._v(" 江苏工会 ")]),_c('p',[_vm._v("12351网上法律服务站")])])])
}]

export { render, staticRenderFns }